import { useMemo, useState, type ReactNode } from 'react';
import { HelpPageContext, type HelpPageSnapshot, type HelpPageValue } from './pageContext';

/** Holds whatever the current screen published; see pageContext.ts. */
export function HelpPageProvider({ children }: { children: ReactNode }) {
  const [snapshot, setSnapshot] = useState<HelpPageSnapshot | null>(null);
  const value = useMemo<HelpPageValue>(() => ({ snapshot, publish: setSnapshot }), [snapshot]);
  return <HelpPageContext.Provider value={value}>{children}</HelpPageContext.Provider>;
}
